import React, { Fragment, useCallback, useContext, useEffect, useState } from 'react'
import CoursesCatalogueFAQIcon from '../../../assets/icons/CoursesCatalogueFAQ.svg';
import CyberRangeFAQIcon from '../../../assets/icons/CyberRangeFAQ.svg';
import AssessmentFAQIcon from '../../../assets/icons/AssessmentFAQ.svg';
import QuizFAQIcon from '../../../assets/icons/QuizFAQ.svg';
import SupportTicketFAQIcon from '../../../assets/icons/SupportTicketFAQ.svg';
import ProfileAccountFAQIcon from '../../../assets/icons/ProfileAccountFAQ.svg';
import GeneralTechnicalFAQIcon from '../../../assets/icons/GeneralTechnicalFAQ.svg';
import DocumentsFAQIcon from '../../../assets/icons/DocumentsFAQ.svg';
import { useNavigate } from 'react-router-dom';
import SharedService from '../../../services/SharedService';
import { FaInfoCircle, FaMinusSquare, FaPlusSquare, FaSearch } from 'react-icons/fa';
import { Skeleton } from 'primereact/skeleton';
import AuthContext from '../../../auth/AuthContext';
import FAQService from '../../../services/FAQService';
import AlertService from '../../../services/AlertService';

const Faq = () => {
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState('');
  const [showAll, setShowAll] = useState(false);
  const [loading, setLoading] = useState(false);
  const [faqs, setFAQs] = useState([]);
  const [filteredFAQs, setFilteredFAQs] = useState([]);
  const [activeIndex, setActiveIndex] = useState();
  const authContext = useContext(AuthContext);

  const handleInputChange = (e) => {
    setSearchValue(e.target.value);
  };

  const groupFAQs = useCallback((faqs) => {
    const parentGroups = Object.groupBy(faqs, d => d.typeDesc || '');
    return Object.entries(parentGroups).map(([tag, items]) => {
      return {
        key: tag,
        items: items,
      };
    });
  }, []);

const loadFAQs = useCallback(async (signal) => { 
    setLoading(true);
    setSearchValue('');
    try {
      const data = await FAQService.GetAllFAQs(
        authContext,
        signal 
      );

      if (signal?.aborted) return; 

      if (data.isSuccess) {
        setFAQs(data.data);
        setFilteredFAQs(groupFAQs(data.data));
        setSearchValue('');
      } else {
        AlertService.error(data.errorMessage);
      }
    } catch (err) {
      if (err.name === "AbortError") return;
    } finally {
      if (!signal?.aborted) setLoading(false); 
    }
  }, [authContext, groupFAQs]);

useEffect(() => {
    const controller = new AbortController(); 
    loadFAQs(controller.signal); 
    return () => controller.abort(); 
  }, [loadFAQs]);

  const handleSubmit = useCallback(() => {
    setFilteredFAQs(() => {
      return groupFAQs(faqs.filter(f => f.question.toLowerCase().indexOf(searchValue) !== -1));
    });
  }, [faqs, groupFAQs, searchValue]);

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSubmit(e);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      handleSubmit();
    }, 100);
    setShowAll(searchValue !== '');
  }, [handleSubmit, searchValue]);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const cards = [{
    id: 1,
    title: 'Course & Catalogue',
    bgColor: '#705F8C',
    icon: CoursesCatalogueFAQIcon,
    marginTop: '25px',
    orderBy: 1,
  }, {
    id: 8,
    title: 'Document',
    bgColor: '#0D3744',
    icon: DocumentsFAQIcon,
    marginTop: '25px',
    orderBy: 2,
  }, {
    id: 2,
    title: 'Bay',
    bgColor: '#6983BD',
    icon: CyberRangeFAQIcon,
    marginTop: '25px',
    orderBy: 3,
  }, {
    id: 3,
    title: 'Assessment',
    bgColor: '#A69054',
    icon: AssessmentFAQIcon,
    marginTop: '25px',
    orderBy: 4,
  }, {
    id: 4,
    title: 'Quiz',
    bgColor: '#7C4386',
    icon: QuizFAQIcon,
    marginTop: '17px',
    orderBy: 5,
  }, {
    id: 5,
    title: 'Support & Ticket',
    bgColor: '#304B58',
    icon: SupportTicketFAQIcon,
    marginTop: '25px',
    orderBy: 6,
  }, {
    id: 6,
    title: 'Profile & Account',
    bgColor: '#1E552D',
    icon: ProfileAccountFAQIcon,
    marginTop: '25px',
    orderBy: 7,
  }, {
    id: 7,
    title: 'General & Technical',
    bgColor: '#7E423A',
    icon: GeneralTechnicalFAQIcon,
    marginTop: '25px',
    orderBy: 8,
  }];

  const onClickHandler = (card) => {
    navigate(`/faq/${SharedService.GenerateSlug(card.title)}`, { state: { id: card.id } });
  }

  return (
    <Fragment>
      <div className="d-flex justify-content-center mt-3 px-3">
      {/* maxWidth inline style for large screens, width 100% for small */}
      <div style={{ maxWidth: '800px', width: '100%' }}>
        <div className="position-relative mb-3">
          
          {/* Search icon position adjusted for mobile */}
          <div
            className="position-absolute top-50 start-0 translate-middle-y ps-3"
            style={{ pointerEvents: 'auto' }} // ensure icon clickable
          >
            <FaSearch
              className="text-muted cursor-pointer"
              onClick={handleSubmit}
              size={18} // icon size can be adjusted
              aria-label="Search"
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
            />
          </div>

          <input
            type="text"
            value={searchValue}
            onChange={handleInputChange}
            onKeyPress={handleKeyPress}
            className="form-control ps-5 custom-input custom-input-color"
            placeholder="Search..."
            style={{
              paddingLeft: '2.5rem',
              paddingRight: '1rem',
              paddingTop: '0.5rem',
              paddingBottom: '0.5rem',
              fontSize: '1rem', // readable font size on mobile
            }}
          />
        </div>
      </div>
    </div>

      {!showAll &&
        <div className="row p-0 m-0">
          {cards.map((m, i) =>
            <div key={i} className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3 p-3">
              <div className="card border-0 shadow h-100 cursor-pointer" onClick={() => onClickHandler(m)}>
                <div className="text-center w-100 mb-2 fw-bold rounded-top-4 " style={{ backgroundColor: m.bgColor, minHeight: '150px' }}></div>
                <center style={{ position: 'absolute', width: '100%', marginTop: m.marginTop }}><img src={m.icon} alt={m.title} className='m-auto'></img></center>
                <div className="text-center fw-light w-100 p-2" style={{ borderRadius: '0px !important', minHeight: "100px" }}>
                  <center className='mt-5 mb-4'>
                    <h5>{m.title}</h5>
                  </center>
                </div>
              </div>
            </div>
          )}
        </div>
      }
      {showAll && filteredFAQs.length > 0 && (
        filteredFAQs.map((parentGroup, i) => (
          <Fragment key={i}>
            <div className="d-flex">
              <div className="text-capitalize px-2 py-2">
                {parentGroup.key || ''}
              </div>
            </div>
            <div className="row">
              {loading ? (
                Array.from({ length: 8 }).map((_, idx) => (
                  <div key={idx} className='col-12 p-2'>
                    <Skeleton width='100%' height='5rem'></Skeleton>
                  </div>
                ))
              ) : (
                <div className="accordion-wrapper">
                  {parentGroup.items && parentGroup.items.length > 0 && parentGroup.items.map((item) =>
                    <div key={item.id} className={`accordion-item border-0 shadow-sm ${activeIndex === item.id ? 'active' : ''}`} >
                      <button
                        className={`accordion-header ${activeIndex === item.id ? 'active' : ''}`}
                        onClick={() => toggleAccordion(item.id)}
                      >
                        <div className="accordion-icon-wrapper">
                         <FaInfoCircle
                          size={20}
                            color={activeIndex === item.id ? "#007bff" : "#9ca3af"}
                            style={{ cursor: "pointer" }}
                          />

                        </div>
                        <span className={`accordion-title ${activeIndex === item.id ? 'active' : ''}`}>{item.question}</span>
                        <div className={`accordion-toggle ${activeIndex === item.id ? 'active' : ''}`}>
                          {activeIndex === item.id ? (<FaMinusSquare color="#2F4156" size={25} />) : (<FaPlusSquare size={25} />)}
                        </div>
                      </button>

                      <div className={`accordion-content ${activeIndex === item.id ? 'open' : ''}`}>
                        <div className="accordion-content-inner">
                          {item.answer}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </Fragment>
        )))}
    </Fragment >
  )
}

export default Faq;